import React from "react";
import { noop } from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Dropdown, DropdownButton, Form, Container, InputGroup, FormControl, Collapse } from "react-bootstrap";
import { Icon, IconButton, useMyDpdTheme } from "@dpdgroupuk/mydpd-ui";
import { SEARCH } from "../../constants";
import "./styles.scss";

const SearchForm = ({
  className,
  searchType,
  searchText,
  types,
  onSubmit,
  onChange
}) => {
  const [submitting, setSubmitting] = React.useState(false);
  const [values, setValues] = React.useState({
    searchType,
    searchText
  });
  const handleChange = React.useCallback((fieldName, value) => {
    setValues(prevValues => {
      const newValues = { ...prevValues,
        [fieldName]: value
      };
      onChange(fieldName, prevValues, newValues); // clear popover if start editing

      return newValues;
    });
  }, [setValues, onChange]);
  const handleTextChange = React.useCallback(e => handleChange("searchText", e.target.value), [handleChange]);
  const handleTypeChange = React.useCallback(eventKey => handleChange("searchType", eventKey), [handleChange]);
  const handleSubmit = React.useCallback(() => {
    setSubmitting(true);
    return onSubmit(values).finally(() => {
      setSubmitting(false);
    });
  }, [onSubmit, values, setSubmitting]);
  const onHandleKeyPress = React.useCallback(event => {
    if (event.key === "Enter") {
      if (!submitting && values.searchText) {
        event.preventDefault();
        event.target.blur();
        handleSubmit();
      }
    }
  }, [handleSubmit, submitting]);
  const onFormSubmit = React.useCallback(e => {
    e.preventDefault();
    handleSubmit();
  }, [handleSubmit]);
  const {
    variant
  } = useMyDpdTheme();
  const [expand, setExpand] = React.useState(false);
  const [openDropdown, setDropDownOpen] = React.useState(false);
  const handleDropdownToggle = React.useCallback(isOpen => {
    setDropDownOpen(isOpen);
  }, [setDropDownOpen]);
  return /*#__PURE__*/React.createElement(Form, {
    inline: true,
    className: classNames("navbar-form navbar-right navbar-form-search", className),
    onSubmit: onFormSubmit
  }, /*#__PURE__*/React.createElement(Collapse, {
    dimension: "width",
    in: expand
  }, /*#__PURE__*/React.createElement(Container, {
    className: classNames("search-form-container", openDropdown && "dropdown-shown")
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "search-input-group h-100"
  }, /*#__PURE__*/React.createElement(DropdownButton, {
    onToggle: handleDropdownToggle,
    title: values.searchType === SEARCH.TYPE.DEL ? SEARCH.DELIVERY : SEARCH.COLLECTION,
    as: InputGroup.Prepend,
    variant: `outline-${variant}`,
    className: "mydpd-navbar-select",
    onSelect: handleTypeChange
  }, types.map((type, index) => /*#__PURE__*/React.createElement(Dropdown.Item, {
    key: index,
    eventKey: type.value,
    active: values.searchType === type.value
  }, type.label))), /*#__PURE__*/React.createElement(FormControl, {
    className: "search-input unset-input h-100",
    "aria-label": "Search",
    "aria-describedby": "basic-search",
    name: "searchText",
    maxLength: "100",
    placeholder: values.searchType === SEARCH.TYPE.DEL ? SEARCH.DELIVERY_SEARCH : SEARCH.COLLECTION_SEARCH,
    onChange: handleTextChange,
    onKeyPress: onHandleKeyPress
  })))), /*#__PURE__*/React.createElement(IconButton, {
    className: "searchbar-icon",
    icon: expand ? /*#__PURE__*/React.createElement(Icon.Close, null) : /*#__PURE__*/React.createElement(Icon.Search, null),
    onClick: e => {
      e.preventDefault();
      setExpand(!expand);
    }
  }));
};

SearchForm.defaultProps = {
  onChange: noop,
  searchType: SEARCH.TYPE.DEL,
  searchText: "",
  types: [{
    value: SEARCH.TYPE.COL,
    label: SEARCH.COLLECTION
  }, {
    value: SEARCH.TYPE.DEL,
    label: SEARCH.DELIVERY
  }]
};
SearchForm.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  searchType: PropTypes.string,
  searchText: PropTypes.string,
  types: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }))
};
export default SearchForm;